module.exports = __webpack_public_path__ + "media/images/cuk-d7dd06e6e739d663ee7819c1b04ba570.jpg";